import {Injectable} from '@angular/core';
import {BaseResolverService} from '@abstract/base-resolver.service';
import {ActivatedRouteSnapshot, Router} from '@angular/router';
import {RequestOptions} from '@abstract/api.service';
import {TechnicalDeviceNamespace} from '@namespaces/technical-device.namespace';
import {TechnicalDeviceElementTypeApiService} from '@api/technical-device-element-type.api.service';

@Injectable()
export class ElementGroupTypesDefaultParamsResolverService extends BaseResolverService {
    constructor(
        service: TechnicalDeviceElementTypeApiService,
        router: Router,
    ) {
        super(service, router);
    }


    getRequestParams(snapshot: ActivatedRouteSnapshot): RequestOptions {
        const elementGroup: TechnicalDeviceNamespace.ElementGroupInterface = snapshot.parent.data.data;

        if (!elementGroup) {
            throw new Error('Cannot get Technical-Device-ElementTypes-Params from routing for resolving «ElementTypeParamsList»');
        }

        const service = this.resolverService as TechnicalDeviceElementTypeApiService;

        return {
            url: service.getParamsPath(elementGroup.type_id, elementGroup.ntd_id),
        };
    }

    processNullData(): any {
        return null;
    }

    /**
     * Обработать ошибку получения данных.
     * Метод можно переопределить в дочерних резолверах и сделать, например, редиректы
     */
    processError() {
        return null;
    }
}
